import { RESULT_BACKGROUNDS, RESULT_RATIOS } from "../resultAssets";
import { FONT_PRESETS, TEXT_STYLES } from "../resultTheme";
import { COLORS } from "../resultTheme";
import {
    KP_DAY_PAIR_STYLE,
    KP_DAY_ZONES,
    KP_NIGHT_ZONES,
    DEFAULT_POST_TYPOGRAPHY,
    createMultiRowSection,
    createPairColumnSection,
    createPairListColumnSection,
    createStandardLayout, NIGHT_A_GROUP,
} from "./sharedLayouts";

const KP_DAY_AFI_FRAME = { top: 17.5, left: 17.3, width: 79, height: 6 };
const KP_DAY_AFI_LAYOUT = {
    groupColumns: 3,
    itemColumns: 2,
    groupGap: "12%",
    itemGap: "8%",
};

const KP_DAY_POST_GROUP_LAYOUT = {
    rows: 3,
};

const KP_DAY_BCD_FRAME = { top: 25, left: 19.8, width: 14, height: 10.5 };
const KP_DAY_NML_FRAME = { top: 41.2, left: 19.8, width: 14, height: 10.5 };
const KP_DAY_PUT_FRAME = { top: 57.2, left: 19.8, width: 14, height: 10.5 };

const KP_DAY_LO_COLUMN_LAYOUT = {
    rowGap: "0%",
    columnGap: "1%",
};

const KP_DAY_LO_COLUMN_1_FRAME = { top: 28.7, left: 36.8, width: 18, height: 65 };
const KP_DAY_LO_COLUMN_2_FRAME = { top: 28.7, left: 57.5, width: 18, height: 65 };
const KP_DAY_LO_COLUMN_3_FRAME = { top: 28.7, left: 78, width: 18, height: 65 };

const NIGHT_LO_LAYOUT = {
    rowGap: "0.3%",
    columnGap: "3%",
    columns: 1,
};

const kpDayTextStyle = TEXT_STYLES.kpDay;

const createKpDayLayout = () => ({
    ratio: RESULT_RATIOS.KP.DAY,
    zones: KP_DAY_ZONES,
    textStyle: kpDayTextStyle,
    sections: [
        createMultiRowSection({
            key: "afi",
            frame: KP_DAY_AFI_FRAME,
            codes: ["A", "F", "I"],
            className: "kp-afi-group",
            layout: KP_DAY_AFI_LAYOUT,
            style: kpDayTextStyle.afi || { fontSize: FONT_PRESETS.lg },
        }),
        createPairColumnSection({
            key: "bcd",
            frame: KP_DAY_BCD_FRAME,
            codes: ["B", "C", "D"],
            className: "kp-post-group",
            layout: KP_DAY_POST_GROUP_LAYOUT,
            style: { ...KP_DAY_PAIR_STYLE, ...kpDayTextStyle.kpPostGroup },
        }),
        createPairColumnSection({
            key: "nml",
            frame: KP_DAY_NML_FRAME,
            codes: ["N", "M", "L"],
            className: "kp-post-group",
            layout: KP_DAY_POST_GROUP_LAYOUT,
            style: { ...KP_DAY_PAIR_STYLE, ...kpDayTextStyle.kpPostGroup },
        }),
        createPairColumnSection({
            key: "put",
            frame: KP_DAY_PUT_FRAME,
            codes: ["P", "U", "T"],
            className: "kp-post-group",
            layout: KP_DAY_POST_GROUP_LAYOUT,
            style: { ...KP_DAY_PAIR_STYLE, ...kpDayTextStyle.kpPostGroup },
        }),
        createPairListColumnSection({
            key: "lo-column-1",
            frame: KP_DAY_LO_COLUMN_1_FRAME,
            columnNumber: 1,
            className: "kp-lo-group",
            layout: KP_DAY_LO_COLUMN_LAYOUT,
            style: kpDayTextStyle.kpLoGroup || {
                twoDColor: COLORS.white,
                threeDColor: COLORS.white,
                fontSize: FONT_PRESETS.sm,
            },
        }),
        createPairListColumnSection({
            key: "lo-column-2",
            frame: KP_DAY_LO_COLUMN_2_FRAME,
            columnNumber: 2,
            className: "kp-lo-group",
            layout: KP_DAY_LO_COLUMN_LAYOUT,
            style: kpDayTextStyle.kpLoGroup || {
                twoDColor: COLORS.white,
                threeDColor: COLORS.white,
                fontSize: FONT_PRESETS.sm,
            },
        }),
        createPairListColumnSection({
            key: "lo-column-3",
            frame: KP_DAY_LO_COLUMN_3_FRAME,
            columnNumber: 3,
            className: "kp-lo-group",
            layout: KP_DAY_LO_COLUMN_LAYOUT,
            style: kpDayTextStyle.kpLoGroup || {
                twoDColor: COLORS.white,
                threeDColor: COLORS.white,
                fontSize: FONT_PRESETS.sm,
            },
        }),
    ],
});

export const kpConfig = {
    bg: RESULT_BACKGROUNDS.KP,
    layout: {
        DAY: createKpDayLayout(),
        NIGHT: createStandardLayout({
            ratio: RESULT_RATIOS.KP.NIGHT,
            zones: KP_NIGHT_ZONES,
            postArea: {
                frame: { left: 11, width: 36 },
                rows: {
                    startTop: 44.5,
                    rowHeight: 8.8,
                },
            },
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: NIGHT_LO_LAYOUT,
            aGroup: NIGHT_A_GROUP,
            textStyle: TEXT_STYLES.kpNight,
        }),
    },
};
